import Vue from "vue";
import App from "./App.vue";
import "./assets/styles.css";
import { extend } from "vee-validate";
import {
  required,
  integer,
  email,
  min_value,
  required_if
} from "vee-validate/dist/rules";

extend("email", { ...email, message: "Please enter a valid email" });
extend("integer", { ...integer, message: "Please enter a valid number" });
extend("min_value", { ...min_value, message: "Please select an option" });
extend("required", {
  ...required,
  message: "This field is required"
});
extend("required_if", {
  ...required_if,
  message: "This field is required"
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#booking-form");
